<template>
	<div>
		<MobileList
			v-if="inMobileApp"
			v-bind="$props"
			@change="$emit('change', $event)"
			@click="$emit('click', $event)"
		/>
		<DesktopList
			v-else
			v-bind="$props"
			@change="$emit('change', $event)"
			@click="$emit('click', $event)"
		/>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import DesktopList from "./Desktop.vue";
import MobileList from "./Mobile.vue";

export default {
	components: {
		DesktopList,
		MobileList,
	},

	props: {
		items: {
			type: Array,
			required: true,
		},
		itemText: {
			type: String,
			default: "title",
		},
		options: {
			type: Array,
			default: () => [],
		},
	},

	computed: {
		...mapGetters({ inMobileApp: "config/inMobileApp" }),
	},
};
</script>

<style lang="scss" scoped>
</style>
